<template>
  <layout-basic>
    <v-container fluid class="pa-4 pa-md-6">
      <div v-if="!ready" class="welcome-loading">
        <v-progress-circular indeterminate color="primary" />
        <p>Loading your first steps…</p>
      </div>
      <!-- The wizard IS the welcome page (18 Sep 2026). A new trial admin
           finishes it before anything else: the menu is locked and the Setup
           guide button hidden until then (5 Oct 2026, wizardLock.js), and the
           wizard offers nothing beside its own steps. -->
      <onboarding-wizard v-else />
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/Dashboard";
import OnboardingWizard from "@/components/authenticated/welcome/OnboardingWizard";
import { isTrialCompanyAdmin } from "@/utils/onboarding";

export default {
  name: "Welcome",
  components: {
    LayoutBasic,
    OnboardingWizard
  },
  data() {
    return {
      ready: false
    };
  },
  mounted() {
    this.bootstrap();
  },
  methods: {
    async bootstrap() {
      if (!this.$store.getters.companyState) {
        try {
          await this.$store.dispatch("profile");
        } catch (e) {
          // Continue with whatever is already in the store
        }
      }
      // TRIAL ADMINS ONLY - the whole point of this page. Paid admins were
      // once redirected in on a fresh browser, and any learner could open
      // /welcome by URL and even flip the company's onboarding state. Gate the
      // PAGE, so every entry path and every build is covered. The wizard
      // loads its own progress from the server.
      if (!isTrialCompanyAdmin(this.$store.getters)) {
        this.$router.replace(
          this.$store.getters.admin ? "/admin/users" : "/"
        );
        return;
      }
      this.ready = true;
    }
  }
};
</script>

<style scoped>
.welcome-loading {
  max-width: 1180px;
  margin: 48px auto;
  text-align: center;
  color: #5a6a7a;
}

.welcome-loading p {
  margin-top: 16px;
}
</style>
